import React from 'react';

import styled from 'styled-components';

import { Icon } from 'apps/auth/components/common/Icon/Icon';

const Container = styled.div`
    text-align: center;
    margin: -4px 0;
    position: relative;
    z-index: 1;
`;

export const LinkedLine: React.FC = () => {
    return (
        <Container>
            <Icon name="link" color="lightGray" />
        </Container>
    );
};
